<template>
  <div class="first">
    <div class="firstTip" v-if="!isOrderEnd && progress == 1">
      根据相关法规要求，且为保护您的账号安全，须验证账号持有人的身份信息，确认用户所绑定的账号为本人持有。
    </div>
    <div
      class="firstMid"
      :class="{
        allComplete: isOrderEnd || progress > 1,
        complete: !isOrderEnd && progress > 1,
      }"
    >
      <div class="firstContent">
        <h3>{{ isOrderEnd ? "基础信息" : "确认基础信息" }}</h3>
        <div class="item">
          <p>订单编号</p>
          <span>
            <img
              @click="copy()"
              id="copycode"
              :data-clipboard-text="data.order_sn"
              src="./../../../../assets/decoration/copy.png"
              alt=""
            />{{ data.order_sn }}</span
          >
        </div>
        <div class="item">
          <p>补贴类型</p>
          <span>{{ data.settle_type_name }}</span>
        </div>
        <div class="item">
          <p>会员手机号</p>
          <span>{{ data.member_phone }}</span>
        </div>
        <div class="item">
          <p>证件类型</p>
          <span>{{ data.auth_type }}</span>
        </div>
        <div class="item">
          <p>真实姓名</p>
          <span>{{ data.realname }}</span>
        </div>
        <div class="item">
          <p>证件号码</p>
          <span>{{ data.id_number }}</span>
        </div>
        <div class="item">
          <p>代理人信息</p>
          <span>{{ data.agent_info ? data.agent_info.phone : "" }}</span>
        </div>
        <div class="item">
          <p>下单时间</p>
          <span>{{ data.created_at }}</span>
        </div>
        <div class="btmBtn" v-if="!isOrderEnd && progress == 1">
          <button @click="nextStep()">下一步</button>
        </div>
      </div>
      <img
        v-if="!isOrderEnd && progress > 1"
        src="./../../../../assets/decoration/order/yqr.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  props: {
    progress: {
      default: 1,
    },
    id: {
      default: "",
    },
    isOrderEnd: {
      default: false,
    },
  },
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api
        .post("decoration/member/order/confirm/info", {
          order_id: this.id,
        })
        .then((res) => {
          this.data = res;
        });
    },
    nextStep() {
      this.$api.get("decoration/basic/csrf/token").then((res) => {
        this.$api
          .post("decoration/member/order/confirm", {
            order_id: this.id,
            csrf_token: res.csrf_token,
          })
          .then((rer) => {
            this.$emit("nextStep");
          });
      });
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.first {
  .firstTip {
    padding: 10px 12px;
    background-color: #ffdbc6;
    color: #ff7e31;
    font-size: 14px;
    line-height: 20px;
  }
  .firstMid {
    margin: 12px 16px;
    padding-bottom: 100px;
    position: relative;
    .firstContent {
      background-color: #ffffff;
      border-radius: 12px;
      padding: 20px 24px;
      h3 {
        display: inline-block;
        font-size: 20px;
        font-weight: 700;
        color: #333333;
        border-bottom: 5px solid #d2c3ff;
        margin: 0 0 16px;
        height: 20px;
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        font-weight: 400;
        margin-top: 20px;
        p {
          color: #999999;
        }
        span {
          color: #333333;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
        }
      }
      .btmBtn {
        position: fixed;
        bottom: 0;
        left: 0;
        height: 83px;
        width: 100%;
        background-color: #ffffff;
        box-shadow: inset 0px 1px 0px 0px #f7f8fc;
        display: flex;
        button {
          flex: 1;
          border: none;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          height: 46px;
          background: #5853e9;
          border-radius: 25px;
          margin: 2px 17px 0;
        }
      }
    }
    > img {
      width: 68px;
      height: 68px;
      position: absolute;
      top: 7px;
      right: 7px;
    }
  }
  .allComplete {
    margin: 12px 0 0;
    padding-bottom: 0px;
    .firstContent {
      border-radius: 16px 16px 0 0;
      h3 {
        font-size: 16px;
        height: 16px;
        margin: 0 0 4px;
      }
    }
  }
  .complete{
    margin: 12px 16px;
  }
}
</style>
